/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue';
import Router from 'vue-router';
import firebase from 'firebase/app';
import 'firebase/auth';
import {db} from '@/firebaseConfig';
import store from './store/store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {x: 0, y: 0};
  },
  routes: [

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home.vue'),
          meta: {authRequired: true}
        },
        {
          path: '/settings',
          name: 'settings',
          component: () => import('./views/infra/Parameters'),
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Parámetros', active: true}
            ],
            pageTitle: 'Parámetros'
          }
        },
        {
          path: '/settings/global-discounts',
          name: 'globalDiscounts',
          component: () => import('./views/infra/GlobalDiscounts'),
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Descuentos globales', active: true}
            ],
            pageTitle: 'Descuentos globales'
          }
        },
        {
          path: '/catalogs/products',
          name: 'products',
          component: () => import('./views/catalogs/products/Products'),
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Productos', active: true}
            ],
            pageTitle: 'Productos'
          }
        },
        {
          path: '/catalogs/product/:id',
          name: 'product',
          component: () => import('./views/catalogs/products/Product'),
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Productos', url: '/catalogs/products'},
              {title: 'Detalle de producto', active: true}
            ],
            pageTitle: 'Detalle de producto'
          }
        },
        {
          path: '/catalogs/categories',
          name: 'categories',
          component: () => import('./views/catalogs/categories/Categories'),
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Categorías', active: true}
            ],
            pageTitle: 'Categorías'
          }
        },
        {
          path: '/catalogs/category/:id',
          name: 'category',
          component: () => import('./views/catalogs/categories/Category'),
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Categorías', url: '/catalogs/categories'},
              {title: 'Detalle de categoría', active: true}
            ],
            pageTitle: 'Detalle de categoría'
          }
        },
        {
          path: '/catalogs/customers',
          name: 'customers',
          component: () => import('./views/catalogs/customers/Customers'),
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Clientes', active: true}
            ],
            pageTitle: 'Clientes'
          }
        },
        {
          path: '/catalogs/customer/:id',
          name: 'customer',
          component: () => import('./views/catalogs/customers/Customer'),
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Clientes', url: '/catalogs/customers'},
              {title: 'Datos de cliente', active: true}
            ],
            pageTitle: 'Datos de cliente'
          }
        },
        {
          path: '/catalogs/coupons',
          name: 'coupons',
          component: () => import('./views/catalogs/coupons/Coupons'),
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Cupones', active: true}
            ],
            pageTitle: 'Cupones'
          }
        },
        {
          path: '/catalogs/coupon/:id',
          name: 'coupon',
          component: () => import('./views/catalogs/coupons/Coupon'),
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Cupones', url: '/catalogs/coupons'},
              {title: 'Datos de Cupones', active: true}
            ],
            pageTitle: 'Datos de Cupones'
          }
        },
        {
          path: '/home/sliders',
          name: 'sliders',
          component: () => import('./views/home/slider/Sliders'),
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Carrusel', active: true}
            ],
            pageTitle: 'Carrusel'
          }
        },
        {
          path: '/home/slider/:id',
          name: 'slider',
          component: () => import('./views/home/slider/Slider'),
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Carrusel', url: '/home/sliders'},
              {title: 'Elemento de carrusel', active: true}
            ],
            pageTitle: 'Elemento de carrusel'
          }
        },
        {
          path: '/home/showcase',
          name: 'showcases',
          component: () => import('./views/home/showcase/Showcases'),
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Destacados', active: true}
            ],
            pageTitle: 'Destacados'
          }
        },
        {
          path: '/home/showcase/:id',
          name: 'showcase',
          component: () => import('./views/home/showcase/Showcase'),
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Destacados', url: '/home/showcase'},
              {title: 'Producto destacado', active: true}
            ],
            pageTitle: 'Producto destacado'
          }
        },
        {
          path: '/statistics/products/period',
          name: 'productSalePeriod',
          component: () => import('./views/statistics/products/ProductSaleStatistics'),
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Estadísticas', url: '/statistics'},
              {title: 'Productos', url: '/statistics/products'},
              {title: 'Período', active: true}
            ],
            pageTitle: 'Venta de productos por período'
          }
        },
        {
          path: '/orders',
          name: 'orders',
          component: () => import('./views/orders/Orders'),
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Órdenes', active: true}
            ],
            pageTitle: 'Órdenes'
          }
        },
        {
          path: '/orders/order/:id',
          name: 'order',
          component: () => import('./views/orders/Order'),
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Órdenes', url: '/orders'},
              {title: 'Detalle de orden', active: true}
            ],
            pageTitle: 'Detalle de orden'
          }
        },
        {
          path: '/reports/orders',
          name: 'ordersReport',
          component: () => import('./views/reports/orders/OrdersReport'),
          meta: {
            breadcrumb: [
              {title: 'Inicio', url: '/'},
              {title: 'Reportes'},
              {title: 'Órdenes', active: true}
            ],
            pageTitle: 'Reporte de órdenes por mes'
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/login',
          name: 'login',
          component: () => import('@/views/pages/Login.vue'),
          meta: {authRequired: false}
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {authRequired: false}
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = "none";
  }
});


/*
router.beforeEach((to, from, next) => {
  firebase.auth().onAuthStateChanged(() => {
    const firebaseCurrentUser = firebase.auth().currentUser;
    if (firebaseCurrentUser && to.name == 'login') {
      router.push({path: '/'});
    } else if (to.meta.authRequired) {
      if (firebaseCurrentUser) {
        if (store.state.AppActiveUser.loggingIn) {
          db.collection('users').doc(firebaseCurrentUser.email).get().then(snapshot => {
            const userData = snapshot.data();
            if (userData) {
              store.commit('UPDATE_USER_INFO', userData, {root: true});
              store.commit('UPDATE_USER_INFO', {userRole: userData.userRole, loggingIn: false}, {root: true});
            }
            router.push({path: '/'});
          });
        } else if (store.state.AppActiveUser.userRole == 'admin') {
          return next();
        } else if (firebaseCurrentUser) {
          store.dispatch('auth/signOut');
        } else {
          router.push({path: '/login'});
        }
      } else {
        router.push({path: '/login'});
      }
    } else if (to.name == 'login') {
      if (firebaseCurrentUser) {
        store.dispatch('auth/signOut');
      } else {
        return next();
      }
    } else {
      return next();
    }
    /!*

      else
        if (to.name == 'login') {
          if (firebaseCurrentUser) {
            store.dispatch('auth/signOut');
          } else {
            return next();
          }
        } else {
          return next();
        }
      }
    *!/
  });
});
*/
router.beforeEach((to, from, next) => {
  // Se guarda la función de desuscripción y se llama en cuanto se recibe el
  // primer evento, para no acumular un listener onAuthStateChanged por cada
  // navegación. Antes, con signInWithRedirect, la recarga completa de página
  // que ocurría al volver de Google limpiaba estos listeners "gratis"; con
  // signInWithPopup la SPA nunca se recarga, por lo que sin este unsubscribe
  // los listeners de navegaciones anteriores se acumulan durante toda la
  // sesión y todos reaccionan simultáneamente a cada cambio de estado de auth.
  const unsubscribe = firebase.auth().onAuthStateChanged(() => {
    unsubscribe();
    const firebaseCurrentUser = firebase.auth().currentUser;
    if (firebaseCurrentUser && to.name == 'login') {
      router.push({path: '/'});
    } else if (to.meta.authRequired) {
      if (firebaseCurrentUser) {
        if (store.state.AppActiveUser.loggingIn) {
          db.collection('users').doc(firebaseCurrentUser.email).get().then(snapshot => {
            const userData = snapshot.data();
            if (userData) {
              store.commit('UPDATE_USER_INFO', userData, {root: true});
              store.commit('UPDATE_USER_INFO', {userRole: userData.userRole, loggingIn: false}, {root: true});
              router.push({path: '/'});
            } else {
              // El usuario se autenticó correctamente contra el proveedor
              // (Google/email) pero no existe su documento de perfil en la
              // colección 'users' de Firestore, por lo que no se le puede
              // asignar un rol. Sin este manejo, 'loggingIn' quedaba
              // atascado en true y esta misma consulta se repetía en cada
              // navegación (bucle de lecturas a Firestore sin fin). Se
              // cierra la sesión y se regresa a login.
              store.commit('UPDATE_USER_INFO', {loggingIn: false}, {root: true});
              firebase.auth().signOut().then(() => {
                router.push({path: '/login'});
              });
            }
          });
        } else if (store.state.AppActiveUser.userRole == 'admin') {
          return next();
        } else if (firebaseCurrentUser) {
          store.dispatch('auth/signOut');
        } else {
          router.push({path: '/login'});
        }
      } else {
        router.push({path: '/login'});
      }
    } else if (to.name == 'login') {
      if (firebaseCurrentUser) {
        store.dispatch('auth/signOut');
      } else {
        return next();
      }
    } else {
      return next();
    }
    /*

      else
        if (to.name == 'login') {
          if (firebaseCurrentUser) {
            store.dispatch('auth/signOut');
          } else {
            return next();
          }
        } else {
          return next();
        }
      }
    */
  });
});

export default router;
